import React, { PropsWithChildren, useState } from 'react';
import {
  EmployerAppSummaryViewType,
  OpinionUpdateViewType,
} from '../types/services-api';

type CandidateListType = {
  [key: string]: EmployerAppSummaryViewType;
};

type CandidateContextType = {
  candidateList: CandidateListType;
  updateOpinion: (
    resume: EmployerAppSummaryViewType,
    updatedOpinion: OpinionUpdateViewType
  ) => void;
  candidateToMessage?: number;
  updateCandidateToMessage: (index?: number) => void;
};

export const CandidateContext = React.createContext<CandidateContextType>({
  candidateList: {},
  updateOpinion: (resume, updatedOpinion) => {},
  updateCandidateToMessage: (index) => {},
});

const CandidateContextProvider = (props: PropsWithChildren) => {
  const [candidateList, setCandidateList] = useState<CandidateListType>({});
  const [candidateToMessage, setCandidateToMessage] = useState<number>();

  function updateOpinion(
    resume: EmployerAppSummaryViewType,
    updatedOpinion: OpinionUpdateViewType
  ) {
    setCandidateList({
      ...candidateList,
      [resume.username]: !!candidateList[resume.username]
        ? {
            ...candidateList[resume.username],
            ...updatedOpinion,
          }
        : {
            ...resume,
            ...updatedOpinion,
          },
    });
  }

  function updateCandidateToMessage(index?: number) {
    setCandidateToMessage(index);
  }

  return (
    <CandidateContext.Provider
      value={{
        candidateList,
        updateOpinion,
        candidateToMessage,
        updateCandidateToMessage,
      }}
    >
      {props.children}
    </CandidateContext.Provider>
  );
};

export default CandidateContextProvider;
